<template>
    <div class="projectAdd">
        <el-breadcrumb class="bread-nav" separator="/">
            <el-breadcrumb-item>首页</el-breadcrumb-item>
            <el-breadcrumb-item>HTML5项目</el-breadcrumb-item>
            <el-breadcrumb-item>添加项目</el-breadcrumb-item>
        </el-breadcrumb>
        <el-form :model="addProjectForm" ref="addProjectForm" :rules="validateRules" label-width="100px" class="addProjectForm">
            <el-form-item label="标题" prop="projectName">
                <el-input v-model="addProjectForm.projectName" placeholder="请填写项目标题"></el-input>
            </el-form-item>
            <el-form-item label="所属大区" prop="company">
                <el-select v-model="addProjectForm.company" placeholder="请选择大区" class="form-select">
                    <el-option v-for="companyItem in companyOptions" :key="companyItem" :label="companyItem" :value="companyItem"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="链接" prop="link">
                <el-input v-model="addProjectForm.link" placeholder="请填写项目正式链接"></el-input>
            </el-form-item>
            <el-form-item label="概述" prop="content">
                <el-input type="textarea" v-model="addProjectForm.content" placeholder="请填写项目概述"></el-input>
            </el-form-item>
            <el-form-item label="项目经理" prop="createUser">
                <el-select v-model="addProjectForm.createUser" placeholder="请选择项目经理" class="form-select">
                    <el-option v-for="userItem in userList" :key="userItem.userId" :label="userItem.userName" :value="userItem.userId"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="addProject('addProjectForm')">立即创建</el-button>
                <el-button @click="clearProjectData">重置</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
import CONFIG from "@/config/index.js";
import TOOL from '@/tool/index.js';
import router from "@/router/index.js";
export default {
    name: "projectAdd",
    data(){
        return {
            userList: null,
            addProjectForm: {
                projectName: null,
                company: null,
                content: null,
                link: null,
                createUser: null
            },
            companyOptions: [
                '华北',
                '华东',
                '华南',
                '本地化事业部',
                '汽车事业部',
                '全国营销中心',
                '效果广告营销中心'
            ],
            validateRules: {
                projectName: [
                    { required: true, message: '请填写项目标题', trigger: 'blur' }
                ],
                company: [
                    { required: true, message: '请选择公司大区', trigger: 'change'}
                ],
                content: [
                    { required: true, message: '请填写项目概述', trigger: 'blur' }
                ],
                link: [
                    { required: true, message: '请填写项目链接', trigger: 'blur' }
                ],
                createUser: [
                    { required: true, type: 'number', message: '请选择用户权限'}
                ]
            }
        };
    },
    mounted(){
        this._init();
    },
    methods: {
        addProject(formName){
            let flag = true;
            this.$refs[formName].validate((valid) => {
                if (!valid) {
                    flag = false;
                    return false;
                }
            });
            if (!flag) {
                return;
            }
            this.$http.post(CONFIG.HOST + '/yysj/add', this.addProjectForm).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.$notify.success({
                        message: '【营销平台】HTML5项目创建成功'
                    });
                    this.clearProjectData();
                    router.push({
                        name: 'h5List'
                    });
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        _getUsers() {
            this.$http.get(CONFIG.HOST + '/users/list' + '?t=' + TOOL.getCurrentTime()).then((response)=>{
                let result = response.body;
                if (result && result.status === 1) {
                    this.userList = result.data;
                } else {
                    this.$notify.error({
                        message: result.message
                    });
                }
            },(response)=>{
                console.log(response);
            });
        },
        clearProjectData(){
            this.addProjectForm.projectName = null;
            this.addProjectForm.company = null;
            this.addProjectForm.content = null;
            this.addProjectForm.link = null;
            this.addProjectForm.createUser = null;
        },
        _init(){
            this._getUsers();
        }
    }
};
</script>
<style lang="less">
    .projectAdd{
        width: 98%;
        margin: 0 auto;
        .bread-nav{
            margin: 20px 0;
        }
        .form-select{
            width: 100%;
        }
    }  
</style>


// WEBPACK FOOTER //
// Add.vue?05a34c74